import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./antd";

import '@/utils/request'

Vue.config.productionTip = false // 这里是什么意思呢？

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
